import React from 'react';
import PdfPage from './PdfPage';

function PdfProfile({ data, officeName, dateLabel }) {
  return (
    <PdfPage officeName={officeName} pageLabel="Profile" dateLabel={dateLabel} className="p02">
      <div className="p02__body">
        <div
          className="p02__photo"
          style={data.photoUrl ? { backgroundImage: `url(${data.photoUrl})` } : undefined}
        />

        <div className="p02__info">
          <div className="p02__chapter">매물 개요</div>
          <h2 className="p02__title">매물기본정보</h2>

          <dl className="p02__specs">
            {data.addressRows.map((row, i) => (
              <div className="full" key={i}>
                <dt>{row.label}</dt>
                <dd>{row.value}</dd>
              </div>
            ))}

            {data.priceRows.map((row, i) => (
              <div
                className={[row.full ? 'full' : '', row.price ? 'price' : ''].filter(Boolean).join(' ')}
                key={`p-${i}`}
              >
                <dt>{row.label}</dt>
                <dd>
                  {row.value}
                  {row.unit && <span className="unit">{row.unit}</span>}
                  {row.sub && <span className="sub">{row.sub}</span>}
                </dd>
              </div>
            ))}

            {data.infoRows.map((row, i) => (
              <div key={`i-${i}`}>
                <dt>{row.label}</dt>
                <dd>
                  {row.value}
                  {row.unit && <span className="unit">{row.unit}</span>}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </PdfPage>
  );
}

export default PdfProfile;
